<template>
  <div>
    <button
      class="hide-button"
      @click="toggleSidebar"
      style="position: absolute;
    top: 93px;
    right: 1.2rem;
    left: unset;
    width: 2rem;
    height: 2rem;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(214, 215, 223);
    border-radius: 50%;
    z-index: 2;
    display: grid;
    place-items: center;
    transition: transform 0.3s ease 0s;"
      :style="{ display: rightSidebarActive ? 'none' : 'grid' }"
    >
      <img src="@/assets/images/ic_round-double-arrow.svg" alt="" style="transform: rotate(180deg);" />
    </button>
    <div class="sidebar-right" :class="{ active: rightSidebarActive }">
      <button class="show-button" @click="toggleSidebar">
        <img src="@/assets/images/ic_round-double-arrow.svg" alt="" />
      </button>
      <div class="sidebar-right--container">
        <template> <slot></slot></template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rightSidebarActive: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-right {
  position: absolute;
  top: 110px;
  right: 0;
  width: 26.1875rem;
  height: calc(100vh - 164px);
  flex-shrink: 0;
  border: 1px solid #e5e7f0;
  background: #f8f8fb;
  box-shadow: 0px 0px 10px 0px rgba(101, 101, 101, 0.05);
}
</style>
